var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-row',{attrs:{"isMine":_vm.isMine,"message":_vm.message}},[_c('div',{staticClass:"face-element-wrapper"},[_c('img',{attrs:{"src":_vm.url}})])])}
var staticRenderFns = []

export { render, staticRenderFns }